import { render, staticRenderFns } from "./UiCreditCard.vue?vue&type=template&id=4f6ac691&"
import script from "./UiCreditCard.vue?vue&type=script&lang=js&"
export * from "./UiCreditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports